import { GET_ALL_DAFFI_USERS, GET_ALL_LOCAL_USERS, REFRESH_APP_DATA } from "helpers/constants";

export const LocalUsers = (localUsers = null, action) => {
	switch (action.type) {
		case GET_ALL_LOCAL_USERS:
			return action.payload;

		default:
			return localUsers;
	}
};

export const DaffiUsers = (daffiUsers = null, action) => {
	switch (action.type) {
		case GET_ALL_DAFFI_USERS:
			return action.payload;

		default:
			return daffiUsers;
	}
};

export const RefreshAppData = (refresh = 0, action) => {
	switch (action.type) {
		case REFRESH_APP_DATA:
			return action.payload;

		default:
			return refresh;
	}
};
